import { render, staticRenderFns } from "./metadata-search.vue?vue&type=template&id=53cec538&"
import script from "./metadata-search.vue?vue&type=script&lang=js&"
export * from "./metadata-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports